import { createBrowserRouter } from "react-router-dom";
import Homepage from "../pages/home";
import FrontLayout from "../layouts/front.layout";
// import AdminLayout from "../layouts/admin.layout";
import AdminLogin from "../pages/admin/login";
import AdminDashboard from "../pages/admin/dashboard";
import OrderDetails from "../pages/admin/order-details";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <FrontLayout />,
    children: [
      {
        path: "/",
        element: <Homepage />,
      },
      {
        path: "/admin",  // This can be simplified since it's the same as /admin
        element: <AdminLogin />,
      },
      {
        path: "/admin/login",  // Just use relative paths
        element: <AdminLogin />,
      },
      {
        path: "/admin/dashboard",  // Use relative path for dashboard
        element: <AdminDashboard />,
      },
      {
        path: "/admin/order/:id",  // Same here, no need to repeat /admin
        element: <OrderDetails />,
      }
    ],
  },
]);
